import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { XmlbeautyPipe } from './xmlbeauty.pipe';
import { Utf8Pipe } from './custom-pipes/utf8.pipe';
import { CustomIconsPipe } from './custom-icons.pipe';
import { BoolStatePipe } from '../components/signaturit/table/pipes/bool-state.pipe';

@NgModule({
  declarations: [
    XmlbeautyPipe,
    Utf8Pipe,
    CustomIconsPipe,
    BoolStatePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'})
  ],
  exports: [
    XmlbeautyPipe,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    Utf8Pipe,
    CustomIconsPipe,
    BoolStatePipe
  ],
  providers: []
})
export class PipesModule { }
